import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import { getFormValues, change, arrayInsert, arrayRemove } from 'redux-form';
import QuickForm from 'components/forms/QuickForm';
import PluginForm from 'components/forms/PluginForm';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as submissionFormActions from 'actions/submissionFormActions';
import * as appActions from 'actions/appActions';
import FormButtons from 'components/FormButtons';
import * as googlePlaceActions from 'actions/googlePlaceActions';
import * as formActions from 'actions/formActions';
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import addHttpPrefix from 'lib/utils/addHttpPrefix';
import styles from './BasicsPage.scss';

class QuickPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    formErrors: ImmutablePropTypes.map.isRequired,
    config: ImmutablePropTypes.map.isRequired,
    pricingTiers: ImmutablePropTypes.map.isRequired,
    currentUser: ImmutablePropTypes.map,
    submitForm: PropTypes.func.isRequired,
    categories: PropTypes.array.isRequired,
    timeZones: PropTypes.array.isRequired,
    saveDraft: PropTypes.func.isRequired,
    countries: PropTypes.object.isRequired,
    clearAddressErrors: PropTypes.func.isRequired,
    venue: PropTypes.object,
    showAppGlobalInfo: PropTypes.func.isRequired,
    hideAppGlobalInfo: PropTypes.func.isRequired,
    formValues: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    currencies: PropTypes.array.isRequired,
    loadPlaceDataFromPlaceId: PropTypes.func.isRequired,
    updateCountryDependencies: PropTypes.func.isRequired,
    updateZipDependencies: PropTypes.func.isRequired,
    showPlugin: PropTypes.bool.isRequired,
    sub_categories: PropTypes.array,
    prices: PropTypes.array,
    urlTypes: PropTypes.array.isRequired,
    title: PropTypes.string,
    ssoGeotixUrl: PropTypes.string,
    online: PropTypes.bool,
    eventbriteEnabled: PropTypes.bool
  };

  componentDidMount() {
    if (this.props.config.get('premium_edit')) {
      this.props.showAppGlobalInfo('Make any necessary edits to your event');
    }
    this.presetTicketsUrl();
    this.requireUrl();
    this.presetDefaultCurrency();
  }

  componentDidUpdate() {
    this.presetEndDate();
    this.updateTicketsUrl();
    this.presetPrices();
  }

  presetEndDate = () => {
    const { start_date, end_date, is_multiday } = this.props.formValues;
    if (is_multiday && start_date && start_date !== 'Invalid date' &&
      (!end_date || end_date === 'Invalid date' || start_date > end_date)) {
      this.props.dispatch(change('eventSubmission', 'end_date', start_date));
    }
  };

  setTicketsUrl = (url) => {
    const index = findIndex(this.props.links, (link) => get(link, 'type.name', '') === 'Tickets');

    if (index > -1) {
      if (url) {
        this.props.dispatch(change('eventSubmission', `links[${index}].url`, addHttpPrefix(url)));
      } else {
        this.props.dispatch(arrayRemove('eventSubmission', 'links', index));
      }
    } else {
      if (!url) return;
      const type = find(this.props.urlTypes, e => e.name === 'Tickets');
      this.props.dispatch(arrayInsert('eventSubmission', 'links', 0, {
        url: addHttpPrefix(url),
        is_primary: this.props.links.length === 0,
        type: { id: type.id, name: type.name }
      }));
    }
  };

  updateTicketsUrl = () => {
    const { dispatch, pricing_type, pricing_url, ticketingUrlType, geotixVanityUrl, ticketsRequired } = this.props;

    if (!ticketsRequired && pricing_type !== 'free') {
      dispatch(change('eventSubmission', 'tickets_required', 'yes'));
    }

    if (ticketsRequired === 'yes' && pricing_type === 'free' && ticketingUrlType === 'no_url'){
      dispatch(change('eventSubmission', 'ticketing_url_type', null));
    }

    if (ticketsRequired === 'no' && (pricing_type !== 'free' || ticketingUrlType !== 'no_url' || pricing_url !== null ) ){
      dispatch(change('eventSubmission', 'pricing_type', 'free'));
      dispatch(change('eventSubmission', 'ticketing_url_type', 'no_url'));
      dispatch(change('eventSubmission', 'pricing_url', null));
    }

    if (ticketingUrlType === 'own_url' && pricing_url === geotixVanityUrl) {
      dispatch(change('eventSubmission', 'pricing_url', null));
    }
  };

  presetTicketsUrl = () => {
    const index = findIndex(this.props.links, (link) => get(link, 'type.name', '') === 'Tickets');
    if (index > -1) {
      this.props.dispatch(change('eventSubmission', 'pricing_url', this.props.links[index].url));
    }

    this.updateTicketsUrl();
  };

  presetPrices() {
    const { currency, pricing_type, ticketingUrlType, prices } = this.props;

    if (!prices.length && (pricing_type === 'tickets_in_advance' || pricing_type === 'registration_required')) {
      this.props.dispatch(arrayInsert('eventSubmission', 'prices', 0, {}));
    }

    prices.map(
      (price, i, arr) => {
        if (i != 0) {
          if (!price.currency || price.currency.value === null) {
            price.currency = arr[i - 1].currency;
          }
        }
        if (price.price === null || pricing_type === 'registration_required' && price.price !== '0.00') {
          this.props.dispatch(change('eventSubmission', `prices[${i}].name`, 'Free'));
          this.props.dispatch(change('eventSubmission', `prices[${i}].price`, '0.00'));
        }

        if (price.price === null || pricing_type === 'tickets_in_advance' && price.price === '0.00') {
          this.props.dispatch(change('eventSubmission', `prices[${i}].name`, 'General Admission'));
          this.props.dispatch(change('eventSubmission', `prices[${i}].price`, ''));
        }

        if (ticketingUrlType === 'geotix' && price.currency
          && price.currency.value !== currency.value) {
          this.props.dispatch(change('eventSubmission', 'ticketing_url_type', 'own_url'));
        }
      }
    );
  }

  presetDefaultCurrency() {
    const defaultCurrency = this.props.ticketingUrlType === 'geotix' ? 'USD' :
      get(this.props.venue, 'country.default_currency', 'USD');
    const newCurrency = this.props.currencies.find((e) => e.value === defaultCurrency);

    if (!this.props.currency || this.props.currency.value !== defaultCurrency) {
      this.props.dispatch(change('eventSubmission', 'currency', newCurrency));
    }

    if (this.props.prices.length) {
      if (!this.props.prices[0].currency || this.props.prices[0].currency.value === null) {
        this.props.prices[0].currency = newCurrency;
      }
      if (!this.props.prices[0].name) {
        this.props.dispatch(change('eventSubmission', 'prices[0].name', 'General Admission'));
      }
    }
  }

  setPrimaryUrl() {
    const { links, dispatch } = this.props;

    if (!links.length) return;
    if (find(links, link => link.is_primary === true)) return;

    const index = findIndex(links, link => get(link, 'type.name', '') === 'Tickets');
    dispatch(change('eventSubmission', `links[${index > -1 ? index : 0}].is_primary`, true));
  }

  submitForm = () => {
    this.checkUrlRequirements();
    this.form.submit();
  }

  checkUrlRequirements = () => {
    this.requireUrl();
    this.removeInvalidUrl();
  }
  
  removeInvalidUrl = () => {
    if (this.props.links.length === 1 && (!this.props.config.get('urls_required', true) || this.props.pricing_url || this.props.ticketingUrlType === 'geotix')) {
      const firstUrl = this.props.links[0];
      if (!firstUrl.url) {
        this.props.dispatch(change('eventSubmission', 'links', []));
      }
    }
  }

  requireUrl = () => {
    if (this.props.links.length === 0 && this.props.config.get('urls_required', true) && !window.GLOBAL_SKIP_VALIDATIONS &&
        !(this.props.ticketingUrlType === 'geotix')) {
      const type = find(this.props.urlTypes, e => e.name === 'Website') || this.props.urlTypes[0];
      this.props.dispatch(arrayInsert('eventSubmission', 'links', 0, {
        url: '',
        is_primary: this.props.links.length === 0,
        type: { id: type.id, name: type.name }
      }));
    }
  }

  state = {
    imageSubmissionRequired: false
  };

  formSubmitted = (data) => {
    // Tickets
    if (data.pricing_type === 'tickets_in_advance' || data.pricing_type === 'registration_required') {
      if (this.props.ticketingUrlType === 'geotix' && !this.props.premiumEdit) {
        this.setTicketsUrl(this.props.geotixVanityUrl);
      } else {
        this.setTicketsUrl(data.pricing_url);
      }
    } else if (data.pricing_type === 'free' && data.ticketing_url_type === 'geotix') {
      this.props.dispatch(change('eventSubmission', 'ticketing_url_type', 'own_url'));
    }
    if (data.pricing_type === 'free') {
      this.setTicketsUrl(null);
    }

    this.setPrimaryUrl();

    // Images
    const images = this.props.submissionForm.getIn(['data', 'images']);

    if (images.size === 0 && this.props.config.get('images_required', true) && !window.GLOBAL_SKIP_VALIDATIONS) {
      this.setState(() => ({ imageSubmissionRequired: true }));
      return;
    }

    this.props.submitForm('quick', this.props.history, data);
    if (this.props.config.get('premium_edit')) {
      this.props.hideAppGlobalInfo();
    }
  };

  saveDraft = () => this.props.saveDraft('quick');
  onEventbriteConnect = () => this.props.authorizeEventbrite();

  onClosePlugin = () => {
    this.props.dispatch(change('eventSubmission', 'show_plugin', false));
  };

  onSubmitPlugin = () => {
    const { venue, category_id, title, online } = this.props;
    if (this.pluginErrors().size) return;

    const ssParams = new URLSearchParams([
      ['form_data[title]', title],
      ['form_data[category_id]', category_id],
      ['form_data[venue][place_id]', venue.place_id],
      ['form_data[online]', online]
    ]);

    const snapSellUrl = location.origin + location.pathname +
      location.search.replace(/force_snap_sell/i, ssParams.toString());

    location.href = snapSellUrl;
  };

  pluginErrors = () => {
    const { venue, category_id, title, online } = this.props;

    let errors = new Map();
    if (!title) errors.set('title', 'Required');
    if (!category_id) errors.set('category_id', 'Required');
    if (!venue.place_id && !online) errors.set('venue', 'Required');

    return errors;
  };


  render() {
    const {
      pricingTiers, currentUser, categories, config, formErrors, countries,
      clearAddressErrors, loadPlaceDataFromPlaceId, showPlugin, currencies,
      sub_categories, category_id, updateCountryDependencies, updateZipDependencies,
      urlTypes, premiumEdit, ssoGeotixUrl, ticketingUrlType, online, timeZones,
      pricing_url, eventbriteEnabled
    } = this.props;

    let showPluginModal = config.get('force_snap_sell');

    return (
      <div className={styles.basicContainer}>
        {showPluginModal && showPlugin && <div className="basic-layover">
          <Card className="plugin-modal">
            <PluginForm
              currentUser={currentUser}
              categories={categories}
              ref={ref => this.form = ref}
              onSubmit={this.onSubmitPlugin}
              config={config}
              formErrors={this.pluginErrors()}
              onVenueSelect={loadPlaceDataFromPlaceId}
              pricingTiers={pricingTiers}
              onClose={this.onClosePlugin}
            />
          </Card>
        </div>}
        <FormButtons top={true} previousVisible={false} onNext={this.submitForm} onSaveDraft={this.saveDraft} />
        <QuickForm
          currentUser={currentUser}
          categories={categories}
          ref={ref => this.form = ref}
          onSubmit={this.formSubmitted}
          config={config}
          formErrors={formErrors}
          availableCountries={countries}
          onClearAddress={clearAddressErrors}
          onVenueSelect={loadPlaceDataFromPlaceId}
          pricingTiers={pricingTiers}
          timeZones={timeZones}
          currencies={currencies}
          category_id={category_id}
          sub_categories={sub_categories}
          onChangeCountry={updateCountryDependencies}
          onChangeZip={updateZipDependencies}
          urlTypes={urlTypes}
          imageErrorVisible={this.state.imageSubmissionRequired}
          premiumEdit={premiumEdit}
          ssoGeotixUrl={ssoGeotixUrl}
          ticketingUrlType={ticketingUrlType}
          pricing_url={pricing_url}
          online={online}
          imagesRequired={this.props.config.get('images_required', true)}
          eventbriteEnabled={eventbriteEnabled}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formValues: getFormValues('eventSubmission')(state),
  urlTypes: state.urlTypes,
  categories: state.categories,
  timeZones: state.timeZones,
  online: state.form.eventSubmission.values.online,
  venue: state.form.eventSubmission.values.venue,
  category_id: state.form.eventSubmission.values.category_id,
  sub_categories: state.form.eventSubmission.values.sub_categories,
  title: state.form.eventSubmission.values.title,
  showPlugin: state.form.eventSubmission.values.show_plugin,
  formErrors: state.submissionForm.getIn(['steps', 'quick', 'errors']),
  currentUser: state.currentUser.get('data'),
  countries: state.countries.get('list'),
  config: state.config,
  eventbriteEnabled: state.config.get('eventbrite_enabled'),
  currencies: state.currencies,
  pricingTiers: state.pricingTiers,
  // from tickets
  links: state.form.eventSubmission.values.links,
  ticketingUrlType: state.form.eventSubmission.values.ticketing_url_type,
  prices: state.form.eventSubmission.values.prices,
  capacity: state.form.eventSubmission.values.capacity,
  currency: state.form.eventSubmission.values.currency,
  geotixEnabled: state.config.get('geotix_enabled'),
  premiumEdit: state.config.get('premium_edit'),
  ssoGeotixUrl: state.config.get('sso_geotix_url'),
  geotixVanityUrl: state.config.get('geotix_vanity_url'),
  pricing_type: state.form.eventSubmission.values.pricing_type,
  pricing_url: state.form.eventSubmission.values.pricing_url,
  ticketsRequired: state.form.eventSubmission.values.tickets_required,
  // from images
  submissionForm: state.submissionForm,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch),
  ...bindActionCreators(appActions, dispatch),
  ...bindActionCreators(googlePlaceActions, dispatch),
  ...bindActionCreators(formActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuickPage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SubmissionSteps/QuickPage.jsx